module.exports = "./app-dist/templates/header-mobile-technology.controller.b9b0c2e99b10505f93bf67afc9468531.html";